import { combineReducers, Reducer, AnyAction } from 'redux';
import { GetJuridicalPersonReducer, GetJuridicalPersonState } from './juridical-person/GetJuridicalPersonReducer';
import { GetProjectInvestedReducer, GetProjectInvestedState } from './project/investment/GetProjectInvestedReducer';
import { ActiveModalsReducer, ActiveModalsState } from './modal/ActiveModalsReducer';
import { DownloadDocumentReducer, DownloadDocumentState } from './project/DownloadDocument.reducer';
import { GetDocumentImageReducer, GetDocumentImageState } from './project/GetDocumentImage.reducer';
import { routerReducer, RouterState } from 'react-router-redux';
import { GetUserReducer, GetUserState } from './user/GetUserReducer';
import { AuthenticationReducer, AuthenticationState } from './AuthenticationReducer';
import { GetPhysicalPersonReducer, GetPhysicalPersonState } from './physical-person/GetPhysicalPersonReducer';
import { PhysicalPersonFormReducer, PhysicalPersonFormState } from './physical-person/PhysicalPersonFormReducer';
import { UpdatePhysicalPersonReducer, UpdatePhysicalPersonState } from './physical-person/UpdatePhysicalPersonReducer';
import {
  GetInvestorTypeReducer,
  GetInvestorTypeState
} from './investor-type/GetInvestorTypeReducer';
import {
  UpdateInvestorTypeReducer,
  UpdateInvestorTypeState
} from './investor-type/UpdateInvestorTypeReducer';
import {
  CreateFilledAptitudeTestReducer,
  CreateFilledAptitudeTestState
} from './filled-test/CreateFilledAptitudeTestReducer';
import { ChangePasswordReducer, ChangePasswordState } from './user/ChangePasswordReducer';
import { IndexProjectsReducer, IndexProjectsState } from './project/IndexProjectsReducer';
import { GetAptitudeTestReducer, GetAptitudeTestState } from './aptitude-test/GetAptitudeTestReducer';
import {
  GetLatestFilledAptitudeTestReducer,
  GetLatestFilledAptitudeTestState
} from './filled-test/GetLatestFilledAptitudeTestReducer';
import { GetProjectReducer, GetProjectState } from './project/GetProjectReducer';
import {
  GetProjectInterestedReducer,
  GetProjectInterestedState
} from './project/interested/GetProjectInterestedReducer';
import {
  CreateProjectInterestedReducer,
  CreateProjectInterestedState
} from './project/interested/CreateProjectInterestedReducer';
import { GetMetricsReducer, GetMetricsState } from './metrics/GetMetricsReducer';
import { GetProjectCapTableReducer, GetProjectCapTableState } from './project/cap-table/GetProjectCapTableReducer';
import { GetImageReducer, GetImageState } from './image/GetImageReducer';
import { GetProjectCommentsReducer, GetProjectCommentsState } from './project/comments/GetProjectCommentsReducer';
import {
  CreateProjectCommentReducer,
  CreateProjectCommentState
} from './project/comments/CreateProjectCommentsReducer';
import {
  CreateProjectChildCommentReducer,
  CreateProjectChildCommentState
} from './project/comments/CreateProjectChildCommentsReducer';
import {
  GetIndexJuridicalPersonsReducer,
  GetIndexJuridicalPersonsState
} from './juridical-person/GetIndexJuridicalPersonReducer';
import { SetInvestmentReducer, SetInvestmentState } from './investment/SetInvestmentReducer';
import {
  UpdateJuridicalPersonReducer,
  UpdateJuridicalPersonState
} from './juridical-person/UpdateJuridicalPersonReducer';
import { JuridicalPersonFormReducer, JuridicalPersonFormState } from './juridical-person/JuridicalPersonFormReducer';
import {
  IndexSectorOfInterestReducer,
  IndexSectorOfInterestState
} from './sector-of-interest/IndexSectorsOfInterestReducer';
import {
  CreateJuridicalPersonReducer,
  CreateJuridicalPersonState
} from './juridical-person/CreateJuridicalPersonReducer';
import {
  IndexInvestmentsReducer,
  IndexInvestmentsState
} from './investment/IndexInvestmentsReducer';
import {
  IndexPersonInvestedProjectsReducer,
  IndexPersonInvestedProjectsState
} from './project/IndexPersonInvestedProjects.reducer';
import {
  IndexPersonInterestedProjectsReducer,
  IndexPersonInterestedProjectsState
} from './project/IndexPersonInterestedProjects.reducer';
import {
  ChangeInvestorTypeReducer,
  ChangeInvestorTypeState
} from './investor-type/ChangeInvestorTypeReducer';
import { GetInvestmentReducer, GetInvestmentState } from './investment/GetInvestmentReducer';
import { GetDocumentPreviewReducer, GetDocumentPreviewState } from './project/GetDocumentPreviewReducer';
import {
  UpdateInvestmentReducer,
  UpdateInvestmentState
} from './investment/UpdateInvestmentReducer';
import {
  CreateCorrectContractState,
  CreateCorrectionContractReducer
} from 'src/reducers/correct-contract/CreateCorrectionContractReducer';
import { ChangeProjectDataReducer, ChangeProjectDataState } from 'src/reducers/project/ChangeProjectDataReducer';
import { ChangeCompanyDataReducer, ChangeCompanyDataState } from 'src/reducers/company/ChangeCompanyDataReducer';
import { UpdateCompanyReducer, UpdateCompanyState } from 'src/reducers/company/UpdateCompanyReducer';
import { UpdateProjectReducer, UpdateProjectState } from 'src/reducers/project/UpdateProjectReducer';
import {
  CreateProjectTeamMemberReducer,
  CreateProjectTeamMemberState
} from 'src/reducers/project/team-members/CreateProjectTeamMemberReducer';
import {
  UpdateProjectTeamMemberReducer,
  UpdateProjectTeamMemberState
} from 'src/reducers/project/team-members/UpdateProjectTeamMemberReducer';
import {
  CreateOfflineInvestorReducer,
  CreateOfflineInvestorState
} from 'src/reducers/project/offline-investor/CreateOfflineInvestorReducer';
import {
  UpdateOfflineInvestorReducer,
  UpdateOfflineInvestorState
} from 'src/reducers/project/offline-investor/UpdateOfflineInvestorReducer';
import { GetInvestorDeckReducer, GetInvestorDeckState } from 'src/reducers/investor-deck/GetInvestorDeckReducer';
import {
  CreateInvestorDeckReducer,
  CreateInvestorDeckState
} from 'src/reducers/investor-deck/CreateInvestorDeckReducer';
import { RequestDueDiligenceReducer, RequestDueDiligenceState } from 'src/reducers/project/RequestDueDiligenceReducer';
import { globalReducer } from './Global.reducer';
import {
  DeleteProjectTeamMemberReducer,
  DeleteProjectTeamMemberState
} from 'src/reducers/project/team-members/DeleteProjectTeamMemberReducer';
import {
  UpdateAmountInvestmentReducer,
  UpdateAmountInvestmentState
} from 'src/reducers/investment/UpdateAmountInvestmentReducer';
import { GetPaymentReducer, GetPaymentState } from 'src/reducers/payment/GetPaymentReducer';
import { SetActiveProfileReducer, SetActiveProfileState } from 'src/reducers/user/SetActiveProfileReducer';
import { CheckRequiredProfileReducer, CheckRequiredProfileState } from 'src/reducers/user/CheckRequiredProfile.reducer';
import { GetHomeBannerReducer, GetHomeBannerState } from 'src/reducers/home-banner/GetHomeBannerReducer';
import { GetTestimonialReducer, GetTestimonialState } from 'src/reducers/testimonial/GetTestimonialReducer';

export interface RootState {
  router: RouterState;
  authentication: AuthenticationState;
  getUser: GetUserState;
  getPhysicalPerson: GetPhysicalPersonState;
  changePhysicalPersonData: PhysicalPersonFormState;
  updatePhysicalPerson: UpdatePhysicalPersonState;
  getInvestorType: GetInvestorTypeState;
  updateInvestorType: UpdateInvestorTypeState;
  changeInvestorType: ChangeInvestorTypeState;
  changePassword: ChangePasswordState;
  indexProjects: IndexProjectsState;
  getAptitudeTest: GetAptitudeTestState;
  createFilledAptitudeTest: CreateFilledAptitudeTestState;
  getLatestFilledAptitudeTest: GetLatestFilledAptitudeTestState;
  getProject: GetProjectState;
  changeProjectData: ChangeProjectDataState;
  updateProject: UpdateProjectState;
  changeCompanyData: ChangeCompanyDataState;
  updateCompany: UpdateCompanyState;
  getProjectInterested: GetProjectInterestedState;
  createProjectInterested: CreateProjectInterestedState;
  getMetrics: GetMetricsState;
  getProjectCapTable: GetProjectCapTableState;
  getImage: GetImageState;
  getProjectComments: GetProjectCommentsState;
  createProjectComment: CreateProjectCommentState;
  createProjectChildComment: CreateProjectChildCommentState;
  getDocumentImage: GetDocumentImageState;
  downloadDocument: DownloadDocumentState;
  activeModals: ActiveModalsState;
  getProjectInvested: GetProjectInvestedState;
  indexInvestments: IndexInvestmentsState;
  setInvestmentData: SetInvestmentState;
  updateInvesment: UpdateInvestmentState;
  indexSectorOfInterest: IndexSectorOfInterestState;
  getIndexJuridicalPersons: GetIndexJuridicalPersonsState;
  getJuridicalPerson: GetJuridicalPersonState;
  indexPersonInvestedProjects: IndexPersonInvestedProjectsState;
  indexPersonInterestedProjects: IndexPersonInterestedProjectsState;
  updateJuridicalPerson: UpdateJuridicalPersonState;
  changeJuridicalPersonData: JuridicalPersonFormState;
  createJuridicalPerson: CreateJuridicalPersonState;
  getInvestment: GetInvestmentState;
  getDocumentPreview: GetDocumentPreviewState;
  getPayment: GetPaymentState;
  createCorrectContract: CreateCorrectContractState;
  createProjectTeamMember: CreateProjectTeamMemberState;
  updateProjectTeamMember: UpdateProjectTeamMemberState;
  deleteProjectTeamMember: DeleteProjectTeamMemberState;
  createOfflineInvestor: CreateOfflineInvestorState;
  updateOfflineInvestor: UpdateOfflineInvestorState;
  getInvestorDeck: GetInvestorDeckState;
  createInvestorDeck: CreateInvestorDeckState;
  requestDueDiligence: RequestDueDiligenceState;
  updateChangeAmount: UpdateAmountInvestmentState;
  setActiveProfile: SetActiveProfileState;
  checkRequiredProfile: CheckRequiredProfileState;
  getHomeBanner: GetHomeBannerState;
  getTestimonial: GetTestimonialState;
}

export const rootReducer: Reducer<RootState> = (state: RootState, action: AnyAction) => {
  let newState = globalReducer(state, action);

  return combineReducers<RootState>({
    router: routerReducer,
    authentication: AuthenticationReducer,
    getUser: GetUserReducer,
    getPhysicalPerson: GetPhysicalPersonReducer,
    changePhysicalPersonData: PhysicalPersonFormReducer,
    updatePhysicalPerson: UpdatePhysicalPersonReducer,
    getInvestorType: GetInvestorTypeReducer,
    updateInvestorType: UpdateInvestorTypeReducer,
    changeInvestorType: ChangeInvestorTypeReducer,
    changePassword: ChangePasswordReducer,
    indexProjects: IndexProjectsReducer,
    getProject: GetProjectReducer,
    changeProjectData: ChangeProjectDataReducer,
    updateProject: UpdateProjectReducer,
    changeCompanyData: ChangeCompanyDataReducer,
    updateCompany: UpdateCompanyReducer,
    getAptitudeTest: GetAptitudeTestReducer,
    createFilledAptitudeTest: CreateFilledAptitudeTestReducer,
    getLatestFilledAptitudeTest: GetLatestFilledAptitudeTestReducer,
    getProjectInterested: GetProjectInterestedReducer,
    createProjectInterested: CreateProjectInterestedReducer,
    getMetrics: GetMetricsReducer,
    getProjectCapTable: GetProjectCapTableReducer,
    getImage: GetImageReducer,
    getProjectComments: GetProjectCommentsReducer,
    createProjectComment: CreateProjectCommentReducer,
    createProjectChildComment: CreateProjectChildCommentReducer,
    getDocumentImage: GetDocumentImageReducer,
    downloadDocument: DownloadDocumentReducer,
    activeModals: ActiveModalsReducer,
    getProjectInvested: GetProjectInvestedReducer,
    setInvestmentData: SetInvestmentReducer,
    updateInvestment: UpdateInvestmentReducer,
    indexInvestments: IndexInvestmentsReducer,
    indexSectorOfInterest: IndexSectorOfInterestReducer,
    getIndexJuridicalPersons: GetIndexJuridicalPersonsReducer,
    getJuridicalPerson: GetJuridicalPersonReducer,
    indexPersonInvestedProjects: IndexPersonInvestedProjectsReducer,
    indexPersonInterestedProjects: IndexPersonInterestedProjectsReducer,
    updateJuridicalPerson: UpdateJuridicalPersonReducer,
    changeJuridicalPersonData: JuridicalPersonFormReducer,
    createJuridicalPerson: CreateJuridicalPersonReducer,
    getInvestment: GetInvestmentReducer,
    getDocumentPreview: GetDocumentPreviewReducer,
    getPayment: GetPaymentReducer,
    createCorrectContract: CreateCorrectionContractReducer,
    createProjectTeamMember: CreateProjectTeamMemberReducer,
    updateProjectTeamMember: UpdateProjectTeamMemberReducer,
    deleteProjectTeamMember: DeleteProjectTeamMemberReducer,
    createOfflineInvestor: CreateOfflineInvestorReducer,
    updateOfflineInvestor: UpdateOfflineInvestorReducer,
    getInvestorDeck: GetInvestorDeckReducer,
    createInvestorDeck: CreateInvestorDeckReducer,
    requestDueDiligence: RequestDueDiligenceReducer,
    updateChangeAmount: UpdateAmountInvestmentReducer,
    setActiveProfile: SetActiveProfileReducer,
    checkRequiredProfile: CheckRequiredProfileReducer,
    getHomeBanner: GetHomeBannerReducer,
    getTestimonial: GetTestimonialReducer,
  })(newState as RootState, action);
};



// WEBPACK FOOTER //
// ./src/reducers/RootReducer.tsx